module.exports = {
  ...require(`../../firebase-config.development`),
  appId: '1:9929677373:web:ba4d8bcb5dcf8e0c',
  measurementId: 'G-2B82C5TGYJ',
};
